import axios from 'axios';
import { STORE_BASE_URL } from '../../services/BaseURL';
import getHeaders from '../../constants/headers';


export const warehouseUserStageProfileWithPriority = (
  warehouseId,
  loggedInUserId,
) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage/' +
      loggedInUserId, // for android use
    headers: getHeaders(),
  });
};


export const warehouseUserStageNewJob = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage-new-job',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const warehouseUserStageJobQrCode = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage-job-qrcode',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const warehouseUserStageDashboard = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage-dashboard',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const warehouseUserStageJob = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage-job',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const warehouseUserStageJobQrcodeNext = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage-job-qrcode/next',


    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};




export const warehouseUserStageJobQrcodePrevious = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house/' +
      warehouseId +
      '/stage-process/user-stage-job-qrcode/previous',


    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

